<template>
  <view class="poster-popup">
    <view class="content">
      <view wx:if="{{ __mpx_mode__ === 'wx' }}" class="title">海报保存成功</view>
      <image wx:if="{{ __mpx_mode__ !== 'web' }}" class="poster-image" src="{{popupData.posterImageUrl}}" />
      <img wx:else class="poster-image" src="{{popupData.posterImageUrl}}" />
    </view>
    <view class="footer">
      <view class="desc">{{ desc }}</view>
      <view class="btn" bindtap="close('知道了')">知道了</view>
    </view>
    <image class="close" src="https://ut-static.udache.com/webx/ut/PCthcfJ-MJ5pEZE5HlUhJ.png" bindtap="close('叉号')"/>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'
import { trackEvent } from '@didi/webx-js'

createComponent({
  properties: {
    popupData: Object,
  },
  attached() {
    trackEvent('userteam_fx_saveposter_float_sw', '浮层页面曝光')
  },
  computed: {
    desc() {
      let text = ''
      if ([ 'web', 'ali' ].includes(__mpx_mode__)) {
        text = '请长按或截图保存到本地相册'
      } else {
        text = '已保存到本地相册'
      }
      if (this.popupData.hasBonus) {
        text += '\n福利金已发放'
      }
      return text
    },
  },
  methods: {
    close(btnText) {
      trackEvent('userteam_fx_saveposter_float_main_ck', '页面按钮「知道了」点击', {
        bt_txt: btnText,
      })
      this.triggerEvent('closePosterPopup')
    },
  },
})
</script>

<style lang="stylus" scoped>
  rpx2vh(_rpx)
    (_rpx / 1334 * 100)vh
  .poster-popup
    z-index 9
    position: fixed
    top: 0
    box-sizing: border-box
    width 100vw
    height 100vh
    background-color: rgba(0, 0, 0, .8)
    .content
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      height rpx2vh(1034)
    .title
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: rpx2vh(46);
      color: #FFF;
      letter-spacing: rpx2vh(2.19);
      text-align: center;
      background url('https://ut-static.udache.com/webx/ut/jH_q77p0Kadgl8bK9Rq2n.png')
      background-size cover
      width rpx2vh(448)
      height rpx2vh(70)
      line-height rpx2vh(70)
      margin-bottom rpx2vh(40)
    .footer
      width 750rpx
      // height: 22.49vh
      height: rpx2vh(300)
      position absolute
      bottom 0
      background-image: linear-gradient(180deg, #FFFFFF 2%, #FFFFFF 41%);
      box-shadow: inset 0px 2rpx 0px 0px rgba(255,255,255,1)
      border-radius: 40rpx 40rpx 0px 0px;
      .btn
        width: rpx2vh(500);
        height: rpx2vh(100);
        background-image: linear-gradient(256deg, #FF6B00 0%, #FF5000 77%);
        border-radius: 50rpx;
        font-family: AlibabaPuHuiTi-Medium;
        font-size: rpx2vh(42);
        color: #FFF;
        text-align: center;
        font-weight: 500;
        line-height rpx2vh(100)
        position absolute
        bottom rpx2vh(40)
        left: 50%;
        transform: translateX(-50%);
      .desc
        font-family: PingFangSC-Regular;
        font-size: rpx2vh(32);
        color: #000;
        letter-spacing: 2rpx;
        text-align: center;
        white-space pre-line
        height rpx2vh(160)
        display: flex;
        align-items: center;
        justify-content: center;
    .poster-image
      width: rpx2vh(450)
      height: rpx2vh(800)
      border-radius: 36rpx
      border: rpx2vh(10) solid #fff;
      // border-bottom: none;
      flex-shrink 0
    .close
      width: 41rpx
      height: 41rpx
      position absolute
      top 80rpx
      right 60rpx
</style>

<script type="application/json" lang="json">
{
  "component": true,
  "usingComponents": {}
}
</script>

